
    <app-json-ld [json]="schemaProperty"></app-json-ld>
    <app-json-ld [json]="schemaBreadcrumbs"></app-json-ld>
  


// WEBPACK FOOTER //
// ./src/app/common-theme/seo/house-details-sd.component.ts.HouseDetailsSdComponent.html